
import { useReducer } from 'react';
import { OnErrorSignature, useCentralApi, useCurrentUser } from 'hooks/shared';

type FieldUpdater = (draftId: any) => Promise<number>;

type useWorkItemDraftFinalizeResult = [
    FieldUpdater,
    boolean
];

type useWorkItemDraftFinalizeSignature = (onError?: OnErrorSignature) => useWorkItemDraftFinalizeResult;

const useWorkItemDraftFinalize: useWorkItemDraftFinalizeSignature = (onError?: OnErrorSignature) => {

    const user = useCurrentUser();
    const fetcher = useCentralApi(user);

    const [ working, setWorking ] = useReducer((state: boolean, value: boolean) => {
        return value;
    }, false);
    
    const finalizeAndCreate = async (draftId: any) => {
        try {
            setWorking(true);            
            const resp = await fetcher(`/api/v3/drafts/workitems/${draftId}/finalize`, {
                method: 'POST',
            }, onError);

            if (!resp.ok) {
                if (resp.status === 400) {
                    return false;
                }
            }

            const result = await resp.json();
            return result.workItemId;
        } catch (err) {
            return false;
        } finally {
            setWorking(false);
        }
    };

    return [
        finalizeAndCreate,
        working
    ];
};

export default useWorkItemDraftFinalize;